import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './workflow-failed-email.action';
import { DossierWorkflow } from '../DossierWorkflow/dossier-workflow.model';
import { resendWorkflowStep } from '../DossierWorkflow/dossier-workflow.action';

@Injectable({ providedIn: 'root' })
export class WorkflowFailedEmailTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                dossier_id: '',
                step_status: null,
                type_text: '',
                trigger_at: '',
                club_name: '',
                member_name: '',
                member_email: '',
                last_resend_at: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'trigger_at';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    dossierId: string = "";
    workflow: DossierWorkflow;
    statuses = [
        {"id": "1", "name": "WORKFLOW.status-pending"},
        {"id": "2", "name": "WORKFLOW.status-completed"},
        {"id": "3", "name": "WORKFLOW.status-skipped"}
    ];

    columns = [
                { prop: 'dossier_id', name: 'WORKFLOW_FAILED_EMAIL.dossier-id', sortable: true, hasFilter: true, filter: "input", widthSet: 80},
                { prop: 'club_name', name: 'WORKFLOW_FAILED_EMAIL.club-name', sortable: true, hasFilter: true, filter: "input", widthSet: 150},
                { prop: 'member_name', name: 'WORKFLOW_FAILED_EMAIL.member-name', sortable: true, hasFilter: true, filter: "input", widthSet: 150},
                { prop: 'member_email', name: 'WORKFLOW_FAILED_EMAIL.member-email', sortable: true, hasFilter: true, filter: "input", widthSet: 260},
                { prop: 'trigger_at', name: 'WORKFLOW_FAILED_EMAIL.triggered-at', sortable: true, hasFilter: true, filter: "date", widthSet: 130},
                // { prop: 'last_resend_at', name: 'WORKFLOW_FAILED_EMAIL.last-resend-at', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'type_text', name: 'WORKFLOW_FAILED_EMAIL.step', sortable: false, hasFilter: false, filter: "input"},
                { prop: 'step_status', name: 'WORKFLOW_FAILED_EMAIL.status', sortable: false, hasFilter: false, filter: "select", options: 'statuses', options_id: "id", options_label: "name", widthSet: 80},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: "", widthSet: 120}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            dossier_id: '',
            step_status: null,
            type_text: '',
            trigger_at: '',
            club_name: '',
            member_name: '',
            member_email: '',
            last_resend_at: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}